export default __webpack_public_path__ + "static/media/16703 - Bojangle.beb18bc5.jpeg";